<template>
  <article>
    <div class="text-center vertical-offset4">
      <tr-typography
        classes="block"
        variant="h3"
      >
        {{ text }}
      </tr-typography>
      <tr-svg-icon
        classes="vertical-offset4"
        size="large"
        name="empty-search"
      />
    </div>
  </article>
</template>

<script>
import TrTypography from './TrTypography.vue';
import TrSvgIcon from './TrSvgIcon.vue';

export default {
  name: 'TrEmptySearchResult',
  components: {
    TrTypography,
    TrSvgIcon
  },
  props: {
    text: {
      required: false,
      type: String,
      default: 'Nenhum dado encontrado'
    }
  }
};
</script>
